import { useState, type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Information, Send } from '@mint-lib/icons';
import {
  Button,
  Chip,
  Divider,
  typographyVariants,
} from '@mint-lib/tw-components';

import { EntitySpecificFields } from '../../types/shared.js';
import SendNewRequestModal from '../modals/SendNewRequestModal/SendNewRequestModal.jsx';
import StatusDetailsModal from '../modals/StatusDetailsModal/StatusDetailsModal.jsx';

type Props = EntitySpecificFields & {
  approvalProcessId: string | null;
};

const RequesterRejected: FC<Props> = ({
  approvalProcessId,
  entityId,
  entityType,
  entityName,
  entitySource,
  entityMetadata,
}) => {
  const { t } = useTranslation('@mint-lib/approval-flow-circuit_v2');
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isNewRequestModalOpen, setIsNewRequestModalOpen] = useState(false);

  const showStatusModal = () => {
    setIsStatusModalOpen(true);
  };
  const closeStatusModal = () => {
    setIsStatusModalOpen(false);
  };

  const showNewRequestModal = () => {
    setIsNewRequestModalOpen(true);
  };
  const closeNewRequestModal = () => {
    setIsNewRequestModalOpen(false);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">
          <span
            className={typographyVariants({
              variant: 'caption1',
              color: 'secondary',
            })}
          >
            {t('Status')}:
          </span>
          <Chip
            className="cursor-pointer"
            variant="outline"
            color="error"
            size="medium"
            onClick={showStatusModal}
          >
            <Information />
            {t('Rejected')}
          </Chip>
        </div>
        <Divider orientation="vertical" className="max-h-6" />
        <Button
          data-dd-action-name="Send new request"
          variant="outlined"
          color="primary"
          size="medium"
          onClick={showNewRequestModal}
          // According to the latest requirements, sending of the rejected flow should be disabled.
          // Once the requester edits the entity data - status of the process resolves to "draft" automatically
          // (websocket handler invalidates queries).
          disabled
        >
          <Send />
          {t('Send for approval')}
        </Button>
      </div>
      <StatusDetailsModal
        open={isStatusModalOpen}
        onClose={closeStatusModal}
        approvalProcessId={approvalProcessId}
        userStatus="requester"
      />
      <SendNewRequestModal
        open={isNewRequestModalOpen}
        onClose={closeNewRequestModal}
        entityType={entityType}
        entityId={entityId}
        entityName={entityName}
        entitySource={entitySource}
        entityMetadata={entityMetadata}
      />
    </>
  );
};

export default RequesterRejected;
